import React from 'react';
import { TagCloud } from '@cp/ds/src/components/tagCloud';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { useIsMobile } from '@cp/ds/src/hooks';
import { Stack } from '@mui/material';
import { IconButton } from '@cp/ds/src/components/iconButton';
import { ArrowDownIcon } from '@cp/ds/src/icons';
import { Box } from '@cp/ui';
import { useSubcatalogSpecializationLinks } from 'src/entities/catalog';
import { CatalogSpecializationTagCloudProps } from './types';

export const CatalogSpecializationTagCloud: React.FC<CatalogSpecializationTagCloudProps> = (props) => {
  const isMobile = useIsMobile();
  const { links, isLoading: isLoadingLinks } = useSubcatalogSpecializationLinks(props);

  return isLoadingLinks ? (
    <ContentSkeleton blocks={1} />
  ) : (
    <Box sx={{ mb: 1 }}>
      <TagCloud
        items={links}
        maxVisibleItemsCountByDefault={isMobile ? 4 : 8}
        size="small"
        unfilled
        {...props}
        slots={{
          more: ({ onOpen }) => (
            <Stack alignItems="center" sx={{ mt: 1 }}>
              <IconButton onClick={onOpen}>
                <ArrowDownIcon />
              </IconButton>
            </Stack>
          ),
        }}
      />
    </Box>
  );
};
